import { useTranslation } from "react-i18next"
import { Modal } from "./Modal"

export const ModalOk = ({ show, body, onClick }) => {
  const { t } = useTranslation()

  return (
    <>
      <Modal
        id="ok-res-modal"
        show={show}
        header={<center>{t(`modals.success.title`)}</center>}
        body={body}
        footer={
          onClick && (
            <button type="button" onClick={onClick} className="btn btn-primary">
              {t("ui.btns.ok")}
            </button>
          )
        }
      />
    </>
  )
}
